import { Timestamp } from "firebase/firestore";
import {
  VirtualPresentationInstance,
  VirtualPresentationInstanceFB,
} from "./virtual-presentations";
import { TenantRecord, TrackedRecord } from "./commons";

export type ApplicationsDict = Record<string, VisaApplication>;
export type ApplicationDoc = { id: string; application: VisaApplication };

export interface VisaApplicationType {
  key: string;
  label: string;
}

export interface VisaApplicationStatus {
  key: string;
  label: string;
  description?: string;
  order?: number;
}

export const APPLICATION_TYPES: VisaApplicationType[] = [
  { key: "seasonal", label: "Seasonal Worker" },
  { key: "regular", label: "Regular Work Visa" },
];

export const APPLICATION_STATUS: VisaApplicationStatus[] = [
  { key: "new", label: "New", description: "New application", order: 0 },
  { key: "imported", label: "Imported", description: "Imported application", order: 1 },
  { key: "verified", label: "Verified data", description: "Verified application data", order: 2 },
  {
    key: "survey_link",
    label: "Link sent",
    description: "Survey link sent to applicant",
    order: 3,
  },
  {
    key: "survey_finished",
    label: "Survey finished",
    description: "This applicant can be assigned a placement",
    order: 4,
  },

  {
    key: "cos_ready",
    label: "Ready for CoS",
    description: "A Cos number can be requested for this application",
    order: 5,
  },
  {
    key: "visa_ready",
    label: "Ready for Visa",
    description: "The visa application can be started for this application",
    order: 6,
  },
  {
    key: "visa_open",
    label: "Visa in process",
    description: "The visa application is in process",
    order: 7,
  },
  {
    key: "visa_completed",
    label: "Visa completed",
    description: "The visa application is completed",
    order: 8,
  },
  {
    key: "visa_payment",
    label: "Payment link sent",
    description: "The visa payment link has been sent",
    order: 9,
  },
  { key: "visa_paid", label: "Visa paid", description: "The visa has been paid", order: 10 },
  {
    key: "visa_tls",
    label: "TLS appointment",
    description: "A TLS account has been created and the candidate has an inteview appointment",
    order: 11,
  },
  {
    key: "visa_granted",
    label: "Visa granted",
    description: "The visa has been granted and can be picked up",
    order: 12,
  },
  {
    key: "visa_rejected",
    label: "Visa rejected",
    description: "The applicant has been rejected a visa",
    order: 13,
  },
  {
    key: "cancelled",
    label: "Cancelled",
    description: "The application has been cancelled by the candidate",
    order: 14,
  },
  {
    key: "request_transfer",
    label: "Transfer requested",
    description: "The worker has requested a transfer to another employer",
    order: 15,
  },
  {
    key: "transferred",
    label: "Transferred",
    description: "The worker has been transferred to another employer",
    order: 16,
  },
  {
    key: "dismissed",
    label: "Dismissed",
    description: "The application has been cancelled by the employer",
    order: 17,
  },
];

export const EMPTY_VISA_APPLICATION: VisaApplication = {
  applicantId: "",
  sponsorId: "",
  seasonId: "",
  type: { ...APPLICATION_TYPES[0] },
  workOrderId: "",
  status: "new",
};

export interface VisaApplication extends TrackedRecord, TenantRecord {
  applicantId: string;
  type: VisaApplicationType;
  status: string;
  cos?: string;
  gwf?: string;
  seasonId: string;
  questionnaireId?: string;
  workOrderId: string;
  alternate_start_date?: string;
  start_date?: string;
  end_date?: string;
  dataForm_expiry_date?: string;
  dataForm_completed?: string;
  privacy_policy_accepted?: boolean;
  sufficient_funds?: boolean;
  visa_application_link?: string;
  virtualPresentation?: VirtualPresentationInstance;
}

export interface VisaApplicationFB extends TrackedRecord, TenantRecord {
  applicantId: string;
  type: VisaApplicationType;
  status: string;
  cos?: string;
  gwf?: string;
  seasonId: string;
  questionnaireId?: string;
  workOrderId: string;
  alternate_start_date?: string;
  start_date?: Timestamp;
  end_date?: Timestamp;
  dataForm_expiry_date?: Timestamp;
  dataForm_completed?: Timestamp;
  privacy_policy_accepted?: boolean;
  sufficient_funds?: boolean;
  visa_application_link?: string;
  virtualPresentation?: VirtualPresentationInstanceFB;
}
